import { render, staticRenderFns } from "./storeDeliveryHis.vue?vue&type=template&id=2651d848&scoped=true"
import script from "./storeDeliveryHis.vue?vue&type=script&lang=js"
export * from "./storeDeliveryHis.vue?vue&type=script&lang=js"
import style0 from "./storeDeliveryHis.vue?vue&type=style&index=0&id=2651d848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651d848",
  null
  
)

export default component.exports